import { SET_CLAIM_DATA, SET_CLAIM_HISTORY_DATA, SET_CLAIM_PROGRESS_DATA, SET_CUSTOMER_DATA } from "../constants/constants";
import { postToController } from "./apiActions";

export const setLoadingAndEmpty = (loading: any, empty: any) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_HISTORY_DATA, payload: {
                isLoading: loading,
                isEmpty: empty
            }
        });
    }
}

export const getClaimProgress = (claimID) => {
    setLoadingAndEmpty(true, false);
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetClaimStepsV2', JSON.stringify({
            Parameter: claimID
        }))
            .then(async Response => {
                dispatch({
                    type: SET_CLAIM_DATA, payload:
                    {
                        claimProgress: Response,
                        selectedClaimProgressStep: Response.claimSteps[0]
                    }
                });

                if (Response && Response !== "") {
                    setLoadingAndEmpty(false, false);
                } else {
                    setLoadingAndEmpty(false, true);
                }
            })
    }
}

export const getStepByName = (stepToFind) => {
    return async (dispatch, getState) => {
        var stepList = getState().claimSubmit.claimProgress.claimSteps.sort(compareOrderAscend);
        var selectedSteps = stepList.filter(x => x.claimStepDescription == stepToFind);
        if (selectedSteps) {
            var stepID = selectedSteps[0].stepId;
            var lastCompleteStep = stepList.filter(x => x.stepId == stepID && (x.isCurrentStatus || x.isComplete)).sort(compareOrderDescend)

            if (lastCompleteStep[0]) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedClaimProgressStep: lastCompleteStep[0],
                    }
                });
            }
            await postToController(dispatch, 'GetClaimProgressFAQ', JSON.stringify({
                ClaimRepairProcessMainID: stepID,
                ClaimType: selectedSteps[0].claimType
            }))
                .then(async Response => {
                    dispatch({
                        type: SET_CLAIM_DATA, payload:
                        {
                            claimsFAQs: Response
                        }
                    });
                })
        }
        await dispatch(getNextProgressStepName());
    };
}

export const getNextProgressStepName = () => {
    return async (dispatch, getState) => {

        var stepList = getState().claimSubmit.claimProgress.claimSteps.sort(compareOrderAscend);
        var selectedStepOrder = getState().claimSubmit.selectedClaimProgressStep.claimRepairProcessMainOrder;
        var selectedStepID = getState().claimSubmit.selectedClaimProgressStep.stepId;
        var nextSteps = stepList.filter(x => x.claimRepairProcessMainOrder > selectedStepOrder && x.stepId !== selectedStepID && x.claimStepDescription.toLowerCase() !== 'car hire');

        if (nextSteps.length > 0) {
            var stepID = nextSteps[0].stepId;
            var lastCompleteStep = stepList.filter(x => x.stepId == stepID).sort(compareOrderDescend)
            if (lastCompleteStep[0]) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        nextStepDescription: lastCompleteStep[0].claimStepDescription,
                        canNavigateToNextStep: lastCompleteStep[0].isCurrentStatus == true || lastCompleteStep[0].isComplete == true,
                    }
                });
            }
            else {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        nextStepDescription: "",
                        canNavigateToNextStep: false,
                    }
                });
            }
        }
        else {
            await dispatch({
                type: SET_CLAIM_DATA, payload: {
                    nextStepDescription: "",
                    canNavigateToNextStep: false,
                }
            });
        }

    };
}

export const getNextStep = () => {
    return async (dispatch, getState) => {

        var stepList = getState().claimSubmit.claimProgress.claimSteps.sort(compareOrderAscend);
        var selectedStepOrder = getState().claimSubmit.selectedClaimProgressStep.claimRepairProcessMainOrder;
        var selectedStepID = getState().claimSubmit.selectedClaimProgressStep.stepId;
        var nextSteps = stepList.filter(x => (x.claimRepairProcessMainOrder > selectedStepOrder && x.stepId !== selectedStepID) && (x.claimStepDescription.toLowerCase() !== 'car hire'));

        if (nextSteps.length > 0) {
            var nextStepName = nextSteps[0].claimStepDescription;
            var lastCompleteStep = nextSteps.filter(x => x.claimStepDescription == nextStepName && (x.isCurrentStatus || x.isComplete)).sort(compareOrderDescend);
            var stepID = nextSteps[0].stepId;
            if (lastCompleteStep[0]) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedClaimProgressStep: lastCompleteStep[0],
                    }
                });
                await postToController(dispatch, 'GetClaimProgressFAQ', JSON.stringify({
                    ClaimRepairProcessMainID: stepID,
                    ClaimType: nextSteps[0].claimType
                }))
                    .then(async Response => {
                        dispatch({
                            type: SET_CLAIM_DATA, payload:
                            {
                                claimsFAQs: Response
                            }
                        });
                    })
            } else if (nextSteps[0]) {
                {
                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            selectedClaimProgressStep: nextSteps[0],
                        }
                    });
                    await postToController(dispatch, 'GetClaimProgressFAQ', JSON.stringify({
                        ClaimRepairProcessMainID: stepID,
                        ClaimType: nextSteps[0].claimType
                    }))
                        .then(async Response => {
                            dispatch({
                                type: SET_CLAIM_DATA, payload:
                                {
                                    claimsFAQs: Response
                                }
                            });
                        })
                }
            }
        }
        await dispatch(getNextProgressStepName());
    };
}

export const getPreviousStep = () => {
    return async (dispatch, getState) => {

        var stepList = getState().claimSubmit.claimProgress.claimSteps.sort(compareOrderDescend);
        var selectedStepOrder = getState().claimSubmit.selectedClaimProgressStep.claimRepairProcessMainOrder;
        var selectedStepID = getState().claimSubmit.selectedClaimProgressStep.stepId;
        var nextSteps = stepList.filter(x => x.claimRepairProcessMainOrder < selectedStepOrder && x.stepId !== selectedStepID && x.claimStepDescription.toLowerCase() !== 'car hire');

        if (nextSteps.length > 0) {
            if (nextSteps[0]) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedClaimProgressStep: nextSteps[0],
                    }
                });
            }
        }

    };
}

export const getCurrentStep = () => {
    return async (dispatch, getState) => {

        var stepList = getState().claimSubmit.claimProgress.claimSteps

        if (stepList) {
            var currentStep = stepList.find(x => x.isCurrentStatus);
            if (currentStep) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedClaimProgressStep: currentStep,
                    }
                });
            }
        }
    };
}

export const getOverview = () => {
    return async (dispatch, getState) => {
        var stepList = getState().claimSubmit.claimProgress.claimSteps;
        if (stepList) {
            var currentStep = stepList.find(x => x.claimStepDescription === "Overview");
            if (currentStep) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedClaimProgressStep: currentStep,
                    }
                });
            }
        }
        await dispatch(getNextProgressStepName());
    };
}

export const getCarHire = () => {
    return async (dispatch, getState) => {

        var stepList = getState().claimSubmit.claimProgress.claimSteps;
        if (stepList) {
            var currentStep = stepList.find(x => x.claimStepDescription === "Car hire");
            if (currentStep) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedClaimProgressStep: currentStep,
                    }
                });
            }
        }
        await dispatch(getNextProgressStepName());
    };
}

export const setIsMobileInfo = (flag: boolean) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                isMobileInfo: flag,
            }
        });
    };
}

function compareOrderAscend(a, b) {
    if (a.claimRepairProcessMainOrder < b.claimRepairProcessMainOrder) {
        return -1;
    }
    if (a.claimRepairProcessMainOrder > b.claimRepairProcessMainOrder) {
        return 1;
    }
    return 0;
}

function compareOrderDescend(a, b) {
    if (a.claimRepairProcessMainOrder > b.claimRepairProcessMainOrder) {
        return -1;
    }
    if (a.claimRepairProcessMainOrder < b.claimRepairProcessMainOrder) {
        return 1;
    }
    return 0;
}